import React from 'react';
import CertificadoContainer from './CertificadoContainer';
import ConstanciaEstudio from './ConstanciaContainer/ConstanciaContainer';
import FloatingWhatsAppButton from "../../WhatsappButton/FloatingWhatsAppButton";

const Documentos = ({idProyecto}) => {
  return ( 
    <div className="documentos">
      <ConstanciaEstudio/>
      <CertificadoContainer idProyecto={idProyecto}/>
      <FloatingWhatsAppButton />
    </div>
   );
}
 
export default Documentos;